import axios from '../axios';
// 证件 列表
export const getBaseEmployeeCertPage = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeCertPage',
        method: 'post',
        data
    })
};
// 证件 保存
export const saveBaseEmployeeCert = data => {
    return axios({
        url: '/api/sys/base/saveBaseEmployeeCert',
        method: 'post',
        data
    })
};
// 证件 修改
export const updateBaseEmployeeCert = data => {
    return axios({
        url: '/api/sys/base/updateBaseEmployeeCert',
        method: 'post',
        data
    })
};
// 证件 删除
export const deleteBaseEmployeeCerts = data => {
    return axios({
        url: '/api/sys/base/deleteBaseEmployeeCerts',
        method: 'post',
        data
    })
};
// 上传图片
export const fileUpload = data => {
    return axios({
        url: '/api/sys/file/upload',
        method: 'post',
        data
    })
};
// 身份证ocr识别
export const ocrIdCar = data => {
    return axios({
        url: '/api/sys/ocr/OcrUtils/ocrIdCar',
        method: 'post',
        data
    })
};
// 银行卡ocr识别
export const ocrBank = data => {
    return axios({
        url: '/api/sys/ocr/OcrUtils/ocrBank',
        method: 'post',
        data
    })
};


// WEBPACK FOOTER //
// ./src/api/moudules/certificate.js